<template>
  <div
    v-if="policy"
    class="fixed inset-0 z-[200] flex flex-col items-center justify-center gap-5 bg-white px-8 text-center"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="force-update-title"
    data-testid="force-update"
  >
    <div class="flex h-20 w-20 items-center justify-center rounded-3xl bg-indigo-600 text-white shadow-lg">
      <svg class="h-10 w-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" /></svg>
    </div>
    <div class="max-w-sm">
      <h1 id="force-update-title" class="text-2xl font-black text-slate-950">Please update the app</h1>
      <p class="mt-3 text-base leading-6 text-slate-600">{{ policy.message }}</p>
      <p class="mt-2 text-xs text-slate-400">Your version {{ APP_VERSION_NAME }} (build {{ APP_VERSION_CODE }}). Needed: build {{ policy.minVersionCode }} or newer.</p>
    </div>
    <button type="button" class="min-h-14 w-full max-w-sm rounded-2xl bg-indigo-600 px-6 text-lg font-bold text-white" data-testid="force-update-button" @click="update">Update now</button>
    <button type="button" class="min-h-11 text-sm font-semibold text-slate-500" @click="recheck">I already updated</button>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { fetchRequiredUpdate, openStoreListing, type AppVersionPolicy } from '@/utils/appUpdate'
import { APP_VERSION_CODE, APP_VERSION_NAME } from '@/utils/appVersion'

const policy = ref<AppVersionPolicy | null>(null)

const recheck = async () => {
  policy.value = await fetchRequiredUpdate()
}

const update = async () => {
  if (policy.value) await openStoreListing(policy.value.storeUrl)
}

// Coming back from the Play Store should clear the screen without restarting the app.
const onVisible = () => {
  if (document.visibilityState === 'visible') void recheck()
}

onMounted(() => {
  void recheck()
  document.addEventListener('visibilitychange', onVisible)
})
onBeforeUnmount(() => document.removeEventListener('visibilitychange', onVisible))
</script>
